import stringUtil from '../utils/stringUtil';
import numberUtil from '../utils/number';
import dateUtil from '../utils/dateTime';

export default {
  data() {
    return {
      rowsPerPageItems: [10, 25, 50, 100, 200, { text: 'All', value: -1 }],
    };
  },
  methods: {
    formattedNumber: numberUtil.commaWithDecimal,
    addComma: numberUtil.comma,
    formattedDateTime: dateUtil.formatDateTimeFromTimeStamp,
    formateDateTimeForDisplay: dateUtil.formateDateTimeForDisplay,
    capitalize: stringUtil.capitalize,
    customSort(items) {
      return items;
    },
    customFilter(items, search) {
      // console.log(items, search, filter);
      // this custom filter will do a multi-match separated by a space.
      // e.g

      if (!search) {
        return items;
      } // if the search is empty just return all the items

      function newFilter(val, searching) {
        return (
          val !== null &&
          ['undefined', 'boolean'].indexOf(typeof val) === -1 &&
          val
            .toString()
            .toLowerCase()
            // .replace(/[^0-9a-zA-Z]+/g, '')
            .indexOf(searching) !== -1
        );
      }

      const needleAry = search
        .toString()
        .toLowerCase()
        .split(' ')
        .filter((x) => x);
      // whenever we encounter a space in our search we will filter for both the first and second word (or third word)

      return items.filter((row) =>
        needleAry.every((needle) => Object.keys(row).some((key) => newFilter(row[key], needle)))
      );
      // foreach needle in our array cycle through the data (row[key]) in the current row looking for a match.
      // .some will return true and exit the loop if it finds one it will return false if it doesnt
      // .every will exit the loop if we dont find a match but will return true if all needles match
      // .filter the rows on each match
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
  },
};
